import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type HotelSegmentDrilldownRoute from 'lumen/routes/hotel/segment-drilldown';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSegmentDrilldownController extends Controller {
  declare model: ModelFrom<HotelSegmentDrilldownRoute>;

  queryParams = [
    'data_replatforming',
    'left_asofDate',
    'left_bookingPeriodEnd',
    'left_bookingPeriodStart',
    'left_cancellationStatuses',
    'left_includeGroupBlock',
    'left_leadTime',
    'left_leadTimeComp',
    'left_lengthOfStay',
    'left_lengthOfStayComp',
    'left_marketSegments',
    'left_roomTypeCategory',
    'left_roomTypes',
    'left_statuses',
    'left_stayPeriodEnd',
    'left_stayPeriodStart',
    'left_weekdays',
    'right_asofDate',
    'right_bookingPeriodEnd',
    'right_bookingPeriodStart',
    'right_cancellationStatuses',
    'right_includeGroupBlock',
    'right_leadTime',
    'right_leadTimeComp',
    'right_lengthOfStay',
    'right_lengthOfStayComp',
    'right_marketSegments',
    'right_roomTypeCategory',
    'right_roomTypes',
    'right_statuses',
    'right_stayPeriodEnd',
    'right_stayPeriodStart',
    'right_weekdays',
  ];

  @service declare currency: Services['currency'];
  @service declare currencyConversion: Services['currency-conversion'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  get iframeQPs(): Record<string, unknown> {
    const iframeQPs: Record<string, unknown> = {
      iframe: 1,
      origin: window.location.origin,
    };

    if (this.currency.selectedCurrency) {
      iframeQPs['currency'] = this.currency.selectedCurrency;
    }

    if (this.currencyConversion.selectedProfileId) {
      iframeQPs['currencyVariant'] = this.currencyConversion.selectedProfileId;
    }

    if (this.hotelAndMarketService.hotel) {
      iframeQPs['subscriptionId'] = this.hotelAndMarketService.hotel.id;
    }

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const value = this[queryParam]!;

      if (value) {
        iframeQPs[queryParam] = value;
      }
    });

    return iframeQPs;
  }

  get urlForEmbeddedApp(): string {
    const { model } = this;

    // @ts-expect-error: Incorrect type
    return `/dashboards/segment-drilldown/${model.spiderId}`;
  }

  constructor() {
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      this[queryParam] = null;
    });
  }
}
